export const MASTERCARD = 'mastercard';
export const MAESTRO = 'maestro';
export const VISA = 'visa';
export const AMEX = 'amex';
export const AMERICAN_EXPRESS = 'american-express';
export const DISCOVER = 'discover';

export const alternateBrandFormats = [
  AMERICAN_EXPRESS
];
